import 'babel-polyfill';

import Vue from 'vue';

import './filters';

// import {
//   Cell,
//   Field,
//   CellGroup,
//   Button,
//   Row,
//   Col,
//   Popup,
//   Dialog,
//   Toast,
//   Icon,
// } from 'vant';

// Vue.component('van-cell', Cell);
// Vue.component('van-field', Field);
// Vue.component('van-cell-group', CellGroup);
// Vue.component('van-button', Button);
// Vue.component('van-row', Row);
// Vue.component('van-col', Col);
// Vue.component('van-popup', Popup);
// Vue.component('van-dialog', Dialog);
// Vue.component('van-toast', Toast);
// Vue.component('van-icon', Icon);

import Vant from 'vant';
import 'vant/lib/vant-css/index.css';

Vue.use(Vant);

import '@/components';

import { App } from './app';
import { router } from './router';
import store from './store';

import '@/styles/index.less';

Vue.config.productionTip = false;

// new Vue({
//   router,
//   store,
//   render: (h) => h(App),
// }).$mount('#app');

new Vue({
  el: '#app',
  router,
  store,
  template: '<app/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/main.ts